import { render, staticRenderFns } from "./Escalation.vue?vue&type=template&id=ffebc9b8&"
import script from "./Escalation.vue?vue&type=script&lang=js&"
export * from "./Escalation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports